// Simple localization
class Loc {

  constructor() {
    // Store translations
    this.lib = {};
  }

  // Initialize with translations
  init(lib) {
    this.lib = lib || {};
  }

  // Translate a string
  t(translation, data) {
    // Console log if missing a translation
    if(this.lib && !this.lib[translation]) {
      console.log(`[QUIZ-WIDGET] Missing translation "${translation}"`);
    }

    // Output translation from library or if missing use the key as translation
    let output = this.lib && (this.lib[translation] || translation);

    // Output with data
    if(data) {
      // With count key we use a plural translation if not 1
      if ('count' in data && data.count !== 1 && this.lib[`${translation} plural`]) {
        output = this.lib[`${translation} plural`];
      }

      // Map data values to output string
      Object.entries(data).forEach(([key, value]) => {
        const regexp = new RegExp(`%${key}%`, 'gi');
        output = output.replace(regexp, value);
      });
    }

    return output;
  }
}

export default new Loc();
